import { Row, Modal } from "antd";
import CsvSelect from "./Modals/Faltantes/UploadCsv/CSVSelect";
import StepsToUpload from "./Modals/Faltantes/UploadCsv/Steps";
import { useUploadCsvSteps } from "../hooks/Faltantes/useUploadCsvSteps";
import EditSenders from "./Modals/Faltantes/UploadCsv/EditSenders";

export const AdministrationFaltantesAddForm = ({ showModal, setShowModal, onRefetch }) => {
  const { current } = useUploadCsvSteps();

  return (
    <>
      <Modal open={showModal} onCancel={() => setShowModal(false)} footer={null} width={600}>
        <Row justify="space-around">
          <div className="input-content-titulo">Cargar faltantes</div>
        </Row>
        <StepsToUpload />
        {current === 0 && <EditSenders />}
        {current === 1 && <CsvSelect setShowModal={setShowModal} onRefetch={onRefetch} />}
      </Modal>
    </>
  );
};
